const en = {
  LAYOUT: {
    SEND: "Send",
    CORS: "Failed to connect to server, please try again later. (CORS)",
    NEXT_PAGE: "Next",
    PREV_PAGE: "Prev",
    ON: "ON",
    OFF: "OFF",
    TITLE: "Title",
    CONTENT: "Content",
    BUTTON: "Button",
    OR: "or",
    DISMISS: "Dismiss",
    BACK: "Return",
    REGION: "Region",
    COUNTRY: "Country",
    COUNTRYCOUNT: "Quantity of Country",
    UPDATE: "Last Update time",
    SEARCH_RESULTS: "Search results",
    DOWNLOAD: "Download",
    UNIT_PL: "User",
    UNIT_MIN: "Minute",
    UNIT_SEC: "Second",
    UNIT_Y: "Year",
    UNIT_M: "Month",
    OFFDAY: "Day off",
    WORKDAY: "Work day",
    D_0: "Sunday",
    D_1: "Monday",
    D_2: "Tuesday",
    D_3: "Wednesday",
    D_4: "Thursday",
    D_5: "Friday",
    D_6: "Saturday",
    LAST_WEEK: "Last week",
    LAST_MONTH: "Last 1 month",
    LAST_THREE_MONTHS: "Last 3 months",
    SATRT_DATE: "Start Date",
    END_DATE: "End Date",
    EMPTY_FILTER: "No results found. Please try other condition in filter",
    EMPTY_ROOM: "Please select the chat room in the list first",
    GET_NEW_MESSAGE: "You received a new message.",
    GET_NEW_LINK: "You received a new link.",
    GET_NEW_FILE: "You received a new file.",
    MSG_OFFLINE:
      "Currently offline, please reconnect to the Internet to continue working.",
    MSG_RECONNECT: "Connection has been restored.",
    MSG_ONLOGOUT:
      "Since you have been idle for a long time, to protect your information security, the system has forced you to log out, please log in again.",
    MSG_ONCLOSE:
      "Chat connection error or interruption, automatically try to reconnect after 10 seconds.",
    MSG_LOGIN_AGAIN: "Please login again.",
    MSG_YOU: "You",
    MSG_RETRACT: "have retracted the message.",
    NEWMSG: "You have a new message",
    BEFORE_CHANGE_ROOM:
      "You have unsent messages, which will be cleared after switching chat rooms.",
    DWONLOAD_ERROR: "File not found.",
    DWONLOAD_ERROR401: "Permission denied, please login first.",
    CONNECTION_STATE: "Connection Status",
    DISCONNECTED: "Connection lost, please try later.",
    RECONNECTING: "Reconnecting.",
    ISTYPING: "is typing",
    AGENTIDLE: "You have a chat room {roomName} pending over {min} min。",
    CONFIRM: "Confirm",
    TOTAL_ITMES: "{total} items.",
    ATTACHMENT: "Attachment",
    NEW_VERSION: "Beta Version",
    OLD_VERSION: "Current Version",
  },
  RULE: {
    FORMATE_ERROR: "Wrong format.",
    REQUIRED: "Required",
    PASSWORD: "Please enter the password.",
    PASSWORD_AGAIN: "Please enter the password again.",
    PASSWORD_CONFIRM: "The passwords entered are inconsistent!",
    PASSWORD_LEN: "6 to 12 characters in length.",
    CANNED_KEYWORD:
      'The beginning must be a "#" half-shaped symbol, with a limit of 2~10 characters',
    EMAIL_FORMATE: "Please enter the correct Email format.",
    EMAIL_FORMATE2: "Please enter a valid ASUS email address.",
    PASSWORD_RULE:
      "Note: Password must be between 15 to 20 characters and contain at least three of the following character types: numbers, uppercase letters, lowercase letters, and special characters.",
  },
  BUTTON: {
    LATER: "Later",
    RESET: "Reset",
    CANCEL: "Cancel",
    SAVE: "Save",
    CONFIRM: "Confirm",
    CREATE: "Create",
    SELECT: "Select",
    SEND: "Send",
    EDIT: "Edit",
    VIEW: "Review",
    SETTING: "Setting",
    ADD: "Add",
    ACCEPT: "Accept",
    REJECT: "Reject",
    JOIN_ROOM: "Joined the chat room",
    UNJOIN_ROOM: "Rejected to join the chat room",
    INVITE: "Invite",
    SEARCH: "Search",
    MORE: "More",
    DELETE: "Delete",
    BACK: "Return",
    NEXT: "Next",
    PREV: "Previous",
    CHANGE: "Change",
    CHANGEPSW: "Change Password",
    EXPORT: "Export",
    SELECT_EXPORT: "Export Selected",
    IMPORT: "Import",
    UPLOAD: "Upload",
    UPDATE: "Update",
    PUBLISHED: "Publish",
    SCHEDULE: "Scheduling",
    ACTION: "Action",
    MANAGE: "Manage",
    MONITOR: "Monitor",
    TRANSFER: "Manual Transfer",
    AUTOTRANSFER: "Auto Transfer",
    SELECTFILE: "Select File",
    GSM_SEARCH: "GSM Inquiry",
    HISTORY_LOG: "Check Chat History",
    CUSTOMER_CREATE_EDIT_NOTE: "Edit",
    BACK_LOGIN: "Back to login",
  },
  FORM: {
    TO: "to",
    STARTTIME: "Start Time",
    ENDTIME: "End Time",
    STARTDATE: "Start Date",
    ENDDATE: "End Date",
    OPT_PUBLISHED: "Published",
    OPT_UNPUBLISHED: "Unpublished",
    OPT_RECALL: "Removed",
    OPT_EXPIRED: "Expired",
    OPT_GENERAL: "General",
    OPT_URGENT: "Urgent",
    OPT_NONSERVICE: "NonService",
    OPT_EC_GENERAL: "EC-General",
    OPT_EC_URGENT: "EC-Urgent",
    OPT_EC_NONSERVICE: "EC-NonService",
    OPT_YES: "Yes",
    OPT_NO: "No",
  },
  MODULE: {
    LOADINGOPTIONS: "Loading Options...",
    SELECT_ALL: "Select All",
    SELECT_REGION: "Select the Region",
    SELECT_COUNTRY: "Select the Country",
    SELECT_REGION_FIRST: "Select the region first.",
    SELECT_COUNTRY_FIRST: "Select the country first.",
    SELECT_SKILL: "Select Skill",
    SELECT_AGENT: "Select Agent",
    SELECT_STATUS: "Select Status",
    COUNTRY_NOASP: "No ASP established for this country",
    COUNTRY_NOSKILL: "No Skill established for this country",
    SELECT_ASP: "Select ASP",
    SELECT_ASP_FIRST: "Select ASP first.",
    ASP_NOSKILL: "This ASP has not added any skill yet",
  },
  NOTIFICATION: {
    STATUS_CHANGE_SUCCESS: "Status successfully changed.",
    LOGIN_FAIL: "Login fails",
    LOGIN_EXPIRE: "Password expired. Please reset.",
    LOGIN_SUCCESS: "Welcome back",
    LOGOUT_SUCCESS: "Logout successfully.",
    VERIFY_ERROR: "Incorrect verification code",
    SYS: "System",
    CONFIRM: "Confirm",
    CANCEL: "Cancel",
    LOGOUT: "Logout",
    DELETE: "Delete",
    SUCCESS: "Success",
    ERROR: "Error",
    NOTICE: "Notice",
    ALERT: "Alert",
    NODATA: "Data is not found.",
    SOMETHING_WENT_WRONG: "Unknown error occurred.",
    CREATE_SUCCESS: "Data has been successfully added",
    SEND_SUCCESS: "Data has been successfully sent",
    UPDATE_SUCCESS: "Data has been successfully updated",
    SAVE_SUCCESS: "Data has been successfully saved",
    DELETE_SUCCESS: "Data has been successfully deleted",
    SCHEDULE_SUCCESS: "Data has been successfully scheduled",
    PUBLISH_SUCCESS: "Data has been successfully published ",
    SETTING_SUCCESS: "Data has been successfully set ",
    PASSWORD_CHANGE_SUCCESS:
      "Password has been successfully changed.Please use the new password for next login.",
    SELECT_READY_AGENT: 'Please choose the agent in "Ready" status in priority',
    CONFIRM_LOGOUT: "Do you want to log out?",
    CONFIRM_LOGOUT_1:
      "The chat is in progress, are you sure you want to log out?",
    CONFIRM_LOGOUT_2: "Do you want to log out?",
    CONFIRM_DELETE: "Do you want to delete this item?",
    CONFIRM_DELETE_SKILL: "Do you want to delete this skill?",
    CONFIRM_DELETE_NOTES: "Do you want to delete this remark?",
    CONFIRM_DELETE_ASP: "Do you want to delete this agent(ASP)?",
    CONFIRM_DELETE_BULLETIN: "Do you want to delete this bulletin?",
    CONFIRM_DELETE_COUNTRY: "Do you want toto delete this country?",
    CONFIRM_DELETE_CANNED: "Do you want to delete this canned message?",
    CONFIRM_PUBLISH: "Do you want to publish the announcement?",
    CONFIRM_SCHEDULE: "Do you want to add this announcement to the schedule?",
    CONFIRM_CREATE_COUNTRY: "Do you want to add this country/area?",
    CONFIRM_CREATE_ASP: "Do you want to add this ASP",
    CONFIRM_CREATE_SKILL: "Do you want to add this skill?",
    CONFIRM_CREATE_ACC: "ADo you want to add this account?",
    CONFIRM_LEAVE_GROUP:
      "After leaving the group, you won't receive the group push notification.",
    CONFIRM_LEAVE_GROUP_MSG: "Are you sure to leave this chat group?",
    CONFIG_ANGENT_UNSEND: "It is not allowed to retract the messages.",
  },
  NAV: {
    HOME: "Home",
    CHAT: "Chat Room",
    HISTORY: "Chat History",
    CHATCASE: "Chat Case",
    REPORT: "Report",
    ACD_MONITOR: "ACD Monitor",
    DASHBOARD: "Dashboard",
    SETTING: "Settings",
    NOTIFY: "Notification",
  },
  LOGIN: {
    EMAIL: "Email",
    PSW: "Enter password",
    REMEMBER: "Remember My ID",
    LOGIN: "Login",
    FORGET_PSW: "Forget Passsword",
    ENTER_EMAIL: "Enter your email",
    ENTER_PSW: "Enter new password",
    ENTER_PSW2: "Confirm new password",
    RESET_SUCCESS: "Passsword reset successfully",
    RESET_SUCCESS_INFO: "Please login again with new password.",
    ENTER_VALIDATE_CODE: "Enter the verification code (case insensitive)",
    SENT_1: "A password reset link has been sent to your mailbox",
    SENT_2: "Mail sent to",
    SENT_3:
      "Please go to check your mailbox, if the letter does not appear in the inbox, please try to check the junk mail. (You can close this page)",
    ENTER_CODE: "Chat Verification Code",
    CODE_SENT: "The verification email has been sent.",
    RESENT: "Resend",
    VERIFY_FAIL: "Verification failed",
  },
  HOME: {
    SERVICE_SKILL: "Service Skill",
    ORDER_RATE: "Chat Case Create Rate",
    WORK_ASSIGNMENT: "Work time distribution",
    CHART_WORK: "Work",
    CHART_BREAK: "Break",
    PICKUP_RATE: "Real-time information",
    TH_SKILL: "Skill",
    TH_INLINE: "Online user Q'ty",
    TH_ONLINE: "Queue Q'ty",
    TH_SERVICED: "Completed Q'ty",
    TH_PICKUPRATE: "Product Percentage",
    SAT: "Satisfaction",
    TH_SAT: "Satisfied",
    TH_UNSAT: "Dissatisfied",
    CODE: "Today's Second Email Verification Code",
  },
  CHAT: {
    CL: {
      TITLE: "Client Chat",
      MYCLIENT: "My Client",
      IDLE: "Idle",
      NO_CLIENT: "No notification from client yet",
      ISSERVICE: "Service status",
      HEAD: {
        TRIGGER_SURVEY: "Trigger Satisfaction Survey",
        SURVEY_TEXT: "{agent} has sent a satisfaction survey",
        TRIGGER_IDLE: "Trigger Idle Reminder",
        TRANSFER: "Transfer",
        FINISH: "End the Chat",
        BLACK: "Block the Client(Black list)",
        NOTE: "Remark",
        COPY_BTN: "Copy to clipboard.",
      },
      FINISH: {
        TITLE: "End The Conversation",
        REASON: "Reason why you end the conversation",
        OTHER_REASON: "Other Reason",
        REASON_1: "Service completed",
        REASON_2: "Customer is not responding",
        REASON_3: "Customer agrees to disconnect",
        REASON_4: "Other",
        REASON_5: "Arrange remote service",
      },
      TRANSFER: {
        TITLE: "Transfer Setting",
        REASON: "Select Why You Transfer",
        REASON_1: "Customer appoints",
        REASON_2: "Wrong Product line(Next,select the correct product)",
        REASON_3: "Major customer complaints(Transfer to supervisor)",
        REASON_4: "Customer needs WebRTC assistance",
        REASON_5: "Other",
        REASON_OTHER: "Please fill in other reasons",
        F_SKILL: "Support Product(Skill)",
        TH_AGENT: "Agent name",
        TH_SKILL: "Product Skill",
        TH_STATUS: "Status",
        NO_AGENT: "No agent/supervisor available for transfer.",
        SELECAGENT: "Select the Agent",
        SELECTED_AGENT: "Agent Selected",
        UNSELECTED_AGENT: "Select which agent to transfer",
        CONFIRM_SELECTED_AGENT: "Transfer to",
        A_ING: "Please wait. The automatic transfer is in progress",
        M_ING: "Please wait. We are transferring you to",
        A_SUCCESS: "The automatic system transfer is successful.",
        M_SUCCESS: "Successfully transferred to",
        AM_FAIL:
          "The transfer failed. Please fill in the reason again and assign to other agent.",
      },
      NOTE: {
        TITLE: "Remark for this customer ",
        CREATE: "Establish new remark",
        EDIT: "Edit the remark",
        CREATE_NOTE: "100 characters at most",
        TH_DATE: "Date",
        TH_AGENT: "Agent",
        TH_CONTENT: "Content",
      },
      INFO: {
        TITLE: "Chat room Information.",
        SUBTITLE_1: "Customer Information.",
        SUBTITLE_2: "Product inquiry",
        SUBTITLE_3: "Chat History",
        SUBTITLE_4: "Remark",
        CU_AVATAR: "Profile picture",
        CU_NAME: "Name",
        CU_EMAIL: "Email",
        CU_ORDER_NO: "Order Number",
        CU_TEL: "Contact",
        CU_TIME: "Local Time",
        CU_LOCAL: "Location",
        CU_DEVICE: "*Device",
        CU_PLATFORM: "Platform",
        PD_TYPE: "*Problem type",
        PD_SKILL: "Product",
        PD_SKILL_NUM: "Product Model.",
        PD_ID: "Product Model SN",
        PD_WARRANTY: "Warranty Territory",
        PD_WARRANTYEND: "Warranty End",
        PD_WARRANTY_REMOTE: "Warranty (Remote Service Only)",
        PD_REMOTE: "Extend Warranty(Remote Service Only)",
        PROBLEM_NOTE: "Problem Note",
        HS_VIEWLOGS: "View logs",
        HS_TODAYINLINE: "Incoming Q'ty today",
        HS_INLINE: "Incoming Q'ty in 30 days",
        HS_LAST_SKILL: "Previous product",
        HS_LAST_SKILL_NUM: "Previous model",
        HS_MODEL_QUICKSEARCH: "Quick Search",
        HS_MODEL_EMPTY: "No records",
        HS_MODEL_1DAY: "Today",
        HS_MODEL_3DAY: "Last 3 days",
        HS_MODEL_7DAY: "Last 7 days",
        EDIT_PRODUCT: "Edit product information",
        GSM_INFO: "GSM information",
        SN_LOCK:
          "(SN Locked) This device is not eligible for ASUS RMA requests. Please contact the original reseller for service.",
        STOLEN: "This product has been marked as 'Stolen.'",
      },
    },
    IN: {
      TITLE: "Internal Chat",
      CREATE: {
        TITLE: "Create Chat group",
        ENTER_GROUPNAME: "Enter group name",
      },
      INFO: {
        TITLE: "Room Information",
        SUBTITLE_1: "Group list",
        INVITE: "Invite the Agent",
      },
      F_SEARCHNAME: "Search for agent name",
      TH_NICKNAME: "Nick name",
      TH_USERNAME: "User name",
      TH_SKILL: "Skill",
      TH_STATUS: "Status",
      TH_UNSELECT: "Select the agent",
      TH_SELECTED: "Selected agent",
    },
    UPLOAD: {
      TITLE: "Upload File",
      DROG: "Drag and drop the file here",
      FORMATE: "File format",
      SIZE: "Maximum size",
      TH_NAME: "Name",
      TH_SIZE: "Size",
      TH_TYPE: "Format",
      SELECT_AT_LEAST_IMAGE: "Please choose at least one picture",
      SELECT_AT_LEAST_FILE: "Please choose at least one file",
      NOT_SUPPORT: "Unsupported file format, please select another file!",
      FILE_LIMIT: "Some files exceed the size limit. Maximum limit is {size}MB",
    },
    LINK: {
      TITLE: "Add the Hyperlink",
      TEXT: "Enter the text",
    },
    CANNED: {
      TITLE: "Canned message",
      NO_GROUP: "You have not established any group ",
      SELECT_GROUP: "Select group",
      SELECT_GROUP_FIRST: "*Please select the group first",
      NO_CATE: "You have not established any category ",
      SELECT_CATE: "Category ",
      ENTER_KEYWORD: "Input keyword filter",
      ENTER_SHORTCUT: "Input keyword search",
      ENTER_SHORTCUT_OR_GROUP: "Please input keyword or select the group",
      NO_CANNED: "You have not esablished any canned message",
    },
    CHATCASE: {
      PROBLEM: {
        COPY_KB: "Copy and quote",
        COPY_SUCCESS: "KB has been saved to clipboard.",
        CLOSE: "Close",
        SELECT: "Quote",
      },
      CREATE_CHATCASE: {
        ALERT: "Tip: KB has not been selected",
      },
    },
  },
  HISTORY: {
    TITLE: "Chat History",
    NAV_TITLE1: "Chat History",
    NAV_TITLE2: "Internal Chat History",
    NAV_TITLE3: "Chat Conversation Search",
    NAV_TITLE4: "Video Call Chat History",
    KEYWORDL: "Keyword",
    TH_DATE: "Date",
    TH_STARTTIME: "Start Time",
    TH_CUST: "User Name",
    TH_CUSTASUSACC: "ASUS Account",
    TH_PRODUCT: "Product",
    TH_PHONE: "User Phone number",
    TH_EMAIL: "User Email",
    TH_SN: "SN",
    TH_SESSIONID: "Session ID",
    TH_ROOMID: "Room ID",
    TH_GROUPNAME: "Group Name",
    TH_CREATOR: "Creator",
    TH_AGENTNAME: "Agent Name",
    TH_AGENTEMAIL: "Agent Email",
    TH_TALKTIME: "Talk Time(s)",
    COPY_BTN: "Copy to clipboard.",
    COPY_SUCCESS: "Successfully saved chat room content to clipboard.",
    SELECT_TYPE: "Please select an export file format.",
  },
  CHATCASE: {
    TITLE: "Chat Case(Beta)",
    TEMP: "Temporary draft, not saved yet.",
    CREATE_CASE: "Create Chatcase",
    EDIT_CASE: "Edit Chatcase",
    DATE: "Date",
    COUNTRY: "Country",
    SKILL: "Skill",
    CHAT_HISTORY: "Chat History",
    SESSION_NO: "Session No.",
    AGENTNAME: "Agent Name",
    LASTSAVETIME: "Last Save Time",
    SUBMITTIME: "Submit Time",
    STATUS: "Status",
    CASE_STATUS: "Case Status",
    CASE_STATUS_NEW: "Open",
    CASE_STATUS_FINISHED: "Close",
    CASE_STATUS_REQUIRED: "Case status is required",
    SPECIAL_FLAG_L2: "Checked with L2",
    ROOM_CHANGED:
      "The chat room has changed. The case form has been reloaded, please check it and submit again.",
    CASENO: "Case No.",
    CMSSERVER: "CSM Server",
    ACTION: "Action",
    DRAFT: "Draft",
    SUBMITTED: "Done",
    UNSUBMITTED: "Unsubmitted",
    EDIT: "Edit",
    BASIC_INFO: "Basic Info",
    AGENT_NAME: "Agent Name",
    CLIENT_NAME: "Client Name",
    PHONE: "Phone",
    EMAIL: "Email",
    PRODUCT: "Product",
    PRODUCT_SN: "ProductSN",
    RMANO: "RMA No.",
    TOPIC: "Topic",
    PROBLEM: "Problem",
    SOLUTION: "Solution",
    DATAREADY: "Data is ready",
    OS: "OS",
    BTN_DRAFT: "Draft",
    BTN_SEND: "Send",
    COPY_CASENO: "The Case No. has been saved to clipboard",
    CASE_CREATED: "Chat Case already exists",
    SN_ERROR: "Please enter the correct ProductSN.",
    SN_ERROR2: "SN cannot be verified, will be submitted as blank.",
    CATA_ERROR: "SN correct, please select product line. (STW failed)",
  },
  REPORT: {
    NAV: {
      TITLE: "Report",
      AGENTSATUS: "Agent Status",
      AGENT_DAILYSATUS: "Agent Daily Status",
      AGENT_DAILYSATUS_CHART: "Agent Daily Status Chart (Beta)",
      AGENT_KPIOCCUPANCY: "Agent KPI and Occupancy (Beta)",
      CSAT: "Satisfaction",
      OVERALL_AGENT_SATISFACTION: "Overall Agent Satisfaction (Beta)",
      OVERALL_SKILL_SATISFACTION: "Overall Skill Satisfaction (Beta)",
      COST: "Billing",
      COST_REPORT: "Billing Report",
      VIDEO_COST_REPORT: "Video Call Billing Report",
      COST_HOURLY: "Hourly Statistics of chat session",
      KPI: "KPI",
      KPI_REPORT: "KPI Report ",
      KPI_REPORT_SKILL: "KPI Report with Skill overview",
      KPI_REPORT_HOURLY: "KPI Report (Hourly)",
      KPI_REPORT_SKILL_HOURLY: "KPI Report with Skill overview (Hourly)",
      AHT_REPORT: "AHT Report",
      AHT_REPORT_SKILL: "AHT Report with Skill overview",
    },
    TH_DATE: "Date",
    TH_AGENT: "Agent",
    TH_CLIENT: "Client Name",
    TH_SKILL: "Skill",
    TH_STARTTIME: "Start Time",
    TH_ENDTIME: "End Time",
    TH_STATUS: "Status",
    TH_DURATION: "Duration",
    TH_CHAT: "Chat",
    TH_CHATTIME: "[C] Chat Time (min)",
    TH_REAYTIME: "[R] Ready Time (min)",
    TH_ACWTIME: "[ACW] ACW Time (min)",
    TH_AUXTIME: "[AUX] AUX Time (min)",
    TH_LOGINTIME: "[L] Login Time (min) (R+C+ACW_AUX)",
    TH_TOTALCHAT: "[TC] Total Chat time(min)",
    TH_OCCUPANCY: "Occupancy (C/L)",
    TH_CONCURRENCY: "Concurrency (TC/L)",
    TH_AHT: "AHT",
    TH_CSAT: "CSAT",
    TH_CHANNEL: "Channel",
    TH_WAITTIME: "Wait Time(Seconds)",
    TH_CUSTOMEREMAIL: "Customer Email",
    TH_CUSTOMERLOCATION: "Customer Location",
    TH_TALKTIME: "Talk Time",
    TH_USERTALK: "User Talks or not",
    TH_COUNTRY: "Country",
    TH_ASP: "Service vendor(ASP)",
    TH_CHATOFFERED: "Chats Provided",
    TH_CHATANS: "Chats Answered",
    TH_ANSRATE: "Answer Rate",
    TH_QTYABD: "Q'ty of Abandoned chat",
    TH_ABDRATE: "Abandon Chat Rate (%)",
    TH_QUEUED: "Queued",
    TH_MAX_TIMETOANS: "Max. Time to Answer chat",
    TH_AVG_TIMETOANS: "Avg. Time to Answer chat",
    TH_MAX_TIMETOABD: "Max. Time to Abandon chat",
    TH_AVG_TIMETOABD: "Avg. Time to Abandon chat",
    TH_AVG_CHATTIME: "Avg. Time in the chat",
    TH_SKILLSLA: "Skill SLA",
    TH_SLA60S: "SLA 60 Seconds(%)",
    TH_CHAT_RECONNECTS: "Numbers of Chat Reconnected",
    TH_CHAT_RECONNECTS_RATE: "Chat Reconnected Rate (%)",
    EXPORT_REGION: "Export Region",
    OPT_SAT: "Please select satisfaction",
    OPT_SAT_ALL: "All",
    OPT_SAT_SATISFIED: "Satisfied",
    OPT_SAT_DISSATISFIED: "Dissatisfied",
  },
  ACD: {
    TITLE: "Automatic Monitoring Chat Distributor ",
    AGENTSTATE: "Agent Status",
    SERVICELEVEL: "Service Level",
    SUMMARY: "Summary",
    TH_HANDLETIME: "Handle Time",
    TH_AGENT: "Agent",
    TH_SKILL: "Skill Set",
    TH_STATUS: "Status",
    TH_STATEDURATION: "Duration of Status",
    TH_CURRENTNUM: "Ongoing Chat",
    TH_MAXNUM: "Max. Chat answered",
    TH_PICKUPNUM: "Total Chat Picked-up.",
    TH_IDLETIME: "Agent Idle Time",
    TH_INCOMING: "Incoming Q'ty",
    TH_ANS: "Answered",
    TH_ANSRATE: "Answer Rate",
    TH_SLA: "SLA",
    TH_SLARATE: "SLA %",
    TH_QUEUED: "Queue Q'ty",
    TH_MAXWAITING: "Max. Waiting Time",
    TH_DISCSAT_COUNT: "Dissatisfaction",
    TH_CSAT_COUNT: "Satisfaction",
    TH_CSAT: "CSAT",
    TH_AHT: "AHT",
    TH_CHATID: "Chat ID",
    TH_PRODUCT: "Product",
    TH_CUSTOMERNAME: "Customer Name",
    TH_STARTTIME: "Start Time",
    TH_DURATION: "Duration",
    TH_LASTMESSAGETIME: "Last Message sent",
    TH_IDLE: "Idle",
    F_AGENTSETTING: "Agent Setting",
    F_AGENTID: "Agent ID",
    F_AGENT: "Agent Name",
    F_SKILL: "Agent Skills",
    F_SUPPORTNUM: "Max. Chat Q'ty",
    D_USERCHATLIST: "'s Chat List",
    D_CHATROOMINFO: "Chat Room Info.",
    D_NOCHAT: "Currently no ongoing sessions",
    D_PRODUCT: "Product",
    D_PRODUCT_SN: "Product SN",
    D_PROBLEMTYPE: "Problem Type",
    D_C_NAME: "Customer Name",
    D_C_PHONENUM: "Customer Phone",
    D_C_EMAIL: "Customer Email",
    D_C_EMPTY: "Blank",
    D_C_NOTE: "Customer Problem Note",
    BTN_RESET_SKILL: "Skill Reset",
    RESET_CONFIRM1: "Do you want to reset the skills of all agents?",
    RESET_CONFIRM2: "Do you want to reset the agent's skills?",
    RESET_SUCCESS: "Agent skills have been reset.",
    FORCE_LOGOUT: "Force Logut",
    FORCE_SET_AGENT_LOGOUT: "Set Agent Logout",
    FORCE_LOGOUT_CONFIRM:
      "Are you sure you want to force logout of this agent?",
    FORCE_LOGOUT_SUCCESS: "Agent has been logged out.",
    QUEUE_NOTICE1: "A user has joined the queue.",
    QUEUE_NOTICE2: "Total number of queued",
  },
  DASHBOARD: {
    TITLE: "Dashboard",
    CLOSED_CASE: "Closed Case",
    INPROCESS_CASE: "In Process",
    AGENT_SATUS: "Agent Status",
    SAT: "Satisfaction",
    C_AGENT_OL: "Agent dropped",
    C_AGENT_OL_I: "Tooltips (Agent disconnected)",
    C_CLIENT_OL: "User dropped",
    C_CLIENT_OL_I: "Tooltips (Client disconnected)",
    C_TIMEOUT_OL: "Timeout ",
    C_TIMEOUT_OL_I: "Tooltips (Disconnection by Timeout)",
    C_OTHER_OL: "Other Disconnection",
    C_OTHER_OL_I: "Tooltips (Other Disconnection)",
    C_AHT_MORE60: "Approach AHT(>1 min)",
    C_AHT_MORE60_I: "Tooltips (more than 1 mins to AHT)",
    C_AHT_IN60: "Approach AHT(<1 min)",
    C_AHT_IN60_I: "Tooltips (less than 1 min to AHT)",
    C_AHT_OVER: "Over AHT",
    C_AHT_OVER_I: "Tooltips (AHT timeout)",
    C_A_READY: "Ready",
    C_A_READY_I: "Tooltips (Ready)",
    C_A_ACW: "ACW",
    C_A_ACW_I: "Tooltips (ACW)",
    C_A_BREAK: "AUX-Break",
    C_A_BREAK_I: "Tooltips (AUX-Break)",
    C_A_MEETTING: "AUX-Meeting",
    C_A_MEETTING_I: "Tooltips (AUX-Meeting)",
    C_SAT: "Satisfied",
    C_SAT_I: "Tooltips (Satisfied)",
    C_UNSAT: "Dissatisfied",
    C_UNSAT_I: "Tooltips (Dissatisfied)",
    C_NOSAT: "No Survey",
    C_NOSAT_I: "Tooltips (No Satisfaction Survey taken)",
    TH_STATUS: "Status",
    TH_AGENTNAME: "Agent",
    TH_CUSTOMER: "Client",
    TH_SAT: "Satisfied",
    TH_UNSAT: "Dissatisfied",
    TH_HANDLETIME: "Handle Time",
    TH_STARTTIME: "Start Time",
    TH_SURVEYTIME: "Survey Time",
    TH_SURVEYCODE: "Survey Results",
  },
  SETTING: {
    INDEX: {
      PERSONAL_SETTING: "Personal Setting",
      PERSONAL_EDIT_PROFILE: "Edit Profile",
      PERSONAL_EDIT_CANNEDRESPONSE_SETTING: "Canned message Setting",
      PUBLIC_CANNEDRESPONSE_LIST: "Public Canned Message List",
      CHAT_SETTING: "Chat Setting",
      CHAT_BASIC_SETTING: "Basic Setting",
      CHAT_SYSTEM_COPYWROTIN_SETTING: "System terms Setting",
      CHAT_CANNEDRESPONSE_SETTING: "Canned message Setting",
      CHAT_BULLETIN_SETTING: "External Bulletin Setting",
      BULLETIN_SETTING: "Bulletin Setting",
      NOTIFY_SETTING: "Notice Setting",
      COUNTRY_SETTING: "Country Setting",
      ASP_SETTING: "ASP Setting",
      SKILL_SETTING: "Skill Setting",
      SKILL_COUNTRY_SETTING: "Skill Setting (Country)",
      SKILL_REGION_SETTING: "Public Skill Setting(Region)",
      SKILL_SCHEDULE_SETTING: "Skill Scheduling Setting",
      ACCOUNT_SETTING: "Account Setting",
      EC_LOGIN: "EC Login Switch",
      GPT_SETTING: "ChatBot",
    },
    PERSONAL: {
      PROFILE: {
        TITLE: "Edit Profile",
        ACC_INFO: "Account Information.",
        ACC: "Account",
        EMAIL: "Email",
        USERNAME: "UserName",
        CURRENTPSW: "Current Password",
        NEWPSW: "New Password",
        NEWPSW2: "Confirm New Password",
        BASIC_SETTING: "Basic Setting",
        AVATAR: "Profile photo",
        UPLOAD_AVATAR: "Upload/Change Profile photo",
        NAME: "Name",
        FIRSTNAME: "FirstName",
        LASTNAME: "LastName",
        NICKNAME: "Nickname",
        GENDER: "Gender",
        MALE: "Male",
        FEMALE: "Female",
        LAN: "Language",
        KBLAN: "KB Preferred Language",
      },
    },
    CANNED: {
      PERSONAL_CANNED_SETTING: "Personal Canned message",
      EDIT_PERSONAL_CANNED: "Edit Personal Canned message",
      EDIT_PUBLIC_CANNED: "Edit Public Canned message",
      CREATE_PERSONAL_CANNED: "Create Personal Canned message",
      CREATE_PUBLIC_CANNED: "Create Public Canned message",
      EDIR_GROUP: "Edit customized group ",
      CREATE_CANNED: "Create",
      IMPORT_CANNED: "Import",
      EXPORT_CANNED: "Export",
      SELECT_FILE: "Please select the file",
      DOWNLOAD_SAMPLE: "Download the sample file",
      CREATE_GROUP: "Create group",
      CREATE_CATE: "Create group",
      EDIT_GROUP: "Edit group",
      EDIT_CATE: "Edit category",
      GROUP_NAME: "Group name",
      CATE_NAME: "Category name",
      SELECTED_FILE: "File selected",
      SELECT_GROUP: "Select the group",
      SELECT_GROUP_FIRST: "Select the group first",
      SELECT_CATE: "Select the catagory",
      ENTER_SHORTCUTS: "Input the keywords",
      TH_GROUP: "Group",
      TH_CATE: "Category",
      TH_SHORTCUTS: "Keyword",
      TH_CONTENT: "Message content",
      TH_CREATOR: "Creator",
      TH_ACTION: "Action",
      EMPTYTEXT: "No Canned message created yet",
      SHORTCUT_INFO:
        "To use canned message during the chat,please input # and keyword。You can also divide each keyword with comma, and also set several keywords for the same message",
      NO_GROUP: "No Group created",
      NO_CATE: "No Category created",
      BEFORE_DELETE_CANNED: "Are you sure to delete this canned message?",
      BEFORE_DELETE_CATE: "Are you sure to delete the category?",
      BEFORE_DELETE_GROUP: "Are you sure to delete the group?",
      PUBLIC_CANNED_SELECT_COUNTRY:
        "Public Canned message setting - Select your country",
      PUBLIC_CANNED: "Public Canned message",
      MANAGE_GROUP: "Manage Product Category",
      AGENT_CANNED: "Agents canned message",
      IDLE_QUICK: " Idle Quick Reply",
    },
    CHAT: {
      BASIC: {
        CHATLIST_FILTER: "Chat List Retrieval Optimization",
        CHATLIST_FILTER_INTRO: "When enabled, the agent's chat list loads all unfinished chats and the finished chats whose finish time is within the retention period set here, instead of all chats of the day.",
        SELECT_COUNTRY: "Basic Setting - Select Country",
        TITLE: "Basic Setting",
        TRANSFER: "File Transfer",
        FILE_TYPE: "File format supported",
        IMAGE_TYPE: "Image format supported",
        AGENT_SEND_FILE: 'Allow agent to send "File" to client',
        AGENT_SEND_IMAGE: 'Allow agent to send "Image" to client',
        AGENT_FILE_LIMIT: 'Max.size of "File" sent by agent',
        AGENT_IMAGE_LIMIT: 'Max. size of "Image" sent by agent',
        PIC_ENCRYPTED: "Picture encrypted",
        CLIENT_SEND_FILE: 'Allow client to send "File" to agent',
        CLIENT_SEND_IMAGE: 'Allow client to send "Image" to agent',
        CLIENT_FILE_LIMIT: 'Max. size of "File" sent from client',
        CLIENT_IMAGE_LIMIT: 'Max. size of "Image" sent from client',
        AGENT_DELETE_MSG: "Agent is allowed to withdraw message",
        AUTO_DAYLIGHT_SAVING: "Auto-adjust daylight saving time",
        PICKUP_TIME: "Pick Up buffer time (seconds)",
        SHOW_SURVEY_RUIE1: "Condition to show the survey (Time)(second)",
        SHOW_SURVEY_RULE1_INTRO:
          "Talk time is less than the indicated time set (second), which means user only enters chat service without any conversation. No survey provided.",
        SHOW_SURVEY_RUIE2: "Condition to show the survey (Message)(Qty)",
        SHOW_SURVEY_RULE2_INTRO:
          "Message from customer is less than the indicated quantity set, which means user only enters chat service without any conversation. No survey provided.",
        SHOW_SURVEY_RUIE3: "User Talk is the necessary condition",
        SHOW_SURVEY_RULE3_INTRO:
          "User only enters chat service without any conversation. No survey provided.",
        AGENT_IDLE_TIMEOUT: "Idle Reminder",
        AGENT_IDLE_TIMEOUT_INTRO: "Pending period to remind the agent",
        IS_AGENT_IDLE:
          "Idle reminder triggers only when the last message is sent by the client.",
        VIDEOCALL_SETTING: "Video Call Setting",
        ISRMANO: "RMA No. Required",
        URL_SETTING: "URL Setting",
        OFFICIAL_URL: "Official site URL",
        ACCOUNT_URL: "Account URL",
      },
      COPYRIGHT: {
        SELECT_COUNTRY: "Copyright Setting - Select Country",
        TITLE_BEFORECHAT: "Copyright Setting - Before the Chat",
        TITLE_ONCHAT: "Copyright Setting - In Chat room",
        TITLE_SAT: "Copyright Setting - Satisfaction",
        TITLE_EC_SAT: "Surevey for Online-Store",
        TITLE_VIDEOCALL: "Copyright Setting - Video Call",
        TAB: {
          BEFORECHAT: "Announcements",
          ONCHAT: "Chat verbiage",
          SAT: "Survey",
          EC_TITLE: "Surevey for Online-Store",
          VIDEOCALL: "Video Call",
        },
        BEFORECHAT: {
          COPYRIGHT: "Copyright Setting",
          SAT_CONSENT: "Satisfaction Consent",
          WELCOME: "Prechat Greeting",
          BBY: "BBY Setting",
          NOSERVICE: "No-service hour",
          SERVICE: "Service hours",
          UNSERVICE: "Service Unavailable",
          BUSY: "Agent Occupied",
          AGE_CHECK: "Age for E-Commerce",
          AGE_LIMIT: "Age Limit",
          NonServiceProduct: "Non-Service Product",
        },
        SERVICE_TYPE: {
          TITLE: "Service Type",
          OPTION: "Option",
          SN: "SN Check",
          SN_CHECK:
            "The feature allows only users with valid SN to access the service.",
        },
        ONCHAT: {
          SELFINTRO: "Agent Self-intro",
          SELFINTRO_INFO:
            "Example: Hello! I am the online service specialist {Agent_Name} and I am very happy to serve for you. How may I help you?",
          IDLE_NOTICE: "Reminding time-out",
          IDEL_NOTICE_TIME: "Idle Time(s)",
          IDEL_NOTICE_TIME_INTRO:
            "When the customer is idle longer than the time set in system, an idle message will show up. (Unit: Second)",
          IDLE_DISCONNECT: "Time-out",
          IDLE_DISCONNECT_TIME: "Disconnect Time(s)",
          IDLE_DISCONNECT_TIME_INTRO:
            "When the customer disconnects longer than the time set in system, the Disconnection message will show up. (Unit: second)",
          TRANSFER_AGENT: "Transferred agent verbiage",
          TRANSFER_AGENT_INTRO:
            "Example: Hello! I'm {Agent_Name}, the agent in charge of {Skill_Name}, and it's a pleasure to serve you. Where can I help you please?",
          BEFOREFINISH: "Notice for user dropped",
          AGENT_DISCONNECT: "Notice for agent dropped",
          CHAT_EXPORT: "Chat export",
          BUTTON_1: "Button 1",
          BUTTON_2: "Button 2",
          BUTTON_PLACEHOLDER: "Enter button text.",
          FINISH_OPTION_1:
            "Button 1. The service completes and go on to the satisfaction survey.",
          FINISH_OPTION_2: "Button 2. Contact the online service agent",
          EXPORT_ALLOW: "Is allow to download",
          EXPORT_WELCOME_TEXT: "Download file welcome sentence",
          EXPORT_PRIVACY_BTN: "Privacy Button",
          EXPORT_PRIVACY_LINK: "Enter privacy link.",
          EXPORT_TERMS_BTN: "Terms Button",
          EXPORT_TERMS_LINK: "Enter terms link.",
          YOUTUBE_NOTE:
            "If left blank, the icon will direct users to the global YouTube channel: ",
        },
        SAT: {
          ISSURVEY: "Survey Required",
          SATISFIED: "Satisfied",
          UNSATISFIED: "Dissatisfied",
          PLACEHOLDER: "Enter the reason/feedback",
          OPTION: "Option",
          OTHER: "Other",
          OTHER_INFO:
            "After opening SAT, the fields for filling-in show on the client side.",
        },
        VIDEOCALL: {
          COPYRIGHT: "Copyright Setting",
          SAT: "Survey for Video Call",
          EMAIL: "Email Setting",
          CONTENT_EXAMPLE_1:
            "A QR Code image and a 'Click here' image with the link will be included in the emails sent to customers. Please place the following two strings (including symbols { }) in the text:",
          CONTENT_EXAMPLE_2:
            "1. {qrcode_image} placed where you want to display the QR Code.",
          CONTENT_EXAMPLE_3:
            "2. {qrcode_link} placed next to the text 'Click here' that you want to display.",
        },
      },
      BULLETIN: {
        SELECT_COUNTRY: "External Bulletin - Select Country",
        TITLE_LIST: "External bulletin",
        TITLE_CREATE: "Establish external bulletin",
        TITLE_EDIT: "Edit external bulletin",
      },
    },
    BULLETIN: {
      SELECT_COUNTRY: "Bulletin Setting - Select Country",
      TITLE_LIST: "Internal bulletin settings",
      TITLE_CREATE: "Establish internal bulletin",
      TITLE_EDIT: "Edit internal bulletin",
      FORM_DATE: "Date of Bulletin created",
      FORM_TO: "to",
      FORM_STARTDATE: "Start date",
      FORM_ENDDATE: "End date",
      FORM_CATEGORY: "Category.",
      FORM_CATE_GENERAL: "General",
      FORM_CATE_EMERGENCY: "Urgent",
      FORM_CATE_NONSERVICE: "NonService",
      FORM_STATUS: "Status",
      FORM_UNPUBLISHED: "Not published",
      FORM_PUBLISHED: "Published",
      TH_DATE: "Creation Date",
      TH_CONTENT: "Content",
      TH_CATEGORY: "Category.",
      TH_COUNTRY: "Country",
      TH_STATUS: "Status",
      TH_STARTTIME: "Start",
      TH_ENDTIME: "End",
      C_SELECT_COUNTRY: "Select Country",
      C_TARGET: "Publish to",
      C_TARGET_AGENT: "Agent",
      C_TARGET_CLIENT: "Client",
      C_CATEGORY: "Message Category.",
      C_SKILLGROUP: "Skill Group",
      C_CONTENT: "Content",
      C_LINK: "Link",
      C_ISSCHED: "Schedule",
      C_ISSCHED_YES: "Yes",
      C_ISSCHED_NO: "No",
      C_SCHED_STARTTIME: "Schedule Starts from",
      C_SCHED_ENDTIME: "Schedule Ends at",
      E_STATUS: "Whether to hide",
      E_STATUS_ACTIVE: "Yes",
      E_STATUS_INACTIVE: "No",
    },
    NOTICE: {
      SELECT_COUNTRY: "Notification Settings - Select Country",
      SELECT_ASP: "Notification Settings - Select ASP",
      TITLE: "Notification Settings",
      SUBTITLE: "Conditions to trigger ,and option settings",
      NOTICE_01: "Number of people waiting in queue",
      NOTICE_02: "Break is too long",
      NOTICE_03: "ACW is too long",
      NOTICE_04: "No agent available in service hour",
      NOTICE_05: "Agent login/logout notification",
      NOTICE_06: "Agent status change",
      NOTICE_07: "Agent HT time is too long",
      NOTICE_08: "Agent network is abnormal",
      NOTICE_09: "DSAT",
      NOTICE_10: "Incoming Volume Anomaly Detection (Beta)",
      LABEL_ONOFF: "OFF/ON",
      LABEL_NOTICETARGET: "Notify",
      LABEL_LINEUP: "Queue Q'ty",
      LABEL_AUX: "AUX",
      LABEL_ACW: "ACW",
      LABEL_HT: "Agent HT time",
      LABEL_TRIGGER: "Trigger rate",
    },
    COUNTRY: {
      TITLE: "Country List",
      SELECT_COUNTRY: "Select Country",
      EDIT_COUNTRY: "Edit Country",
      COUNTRY_CODE: "Country Code",
      COUTNRY_NAME: "Country Name",
      REGION: "Region",
      TIMEZONE: "Time Zone",
      DST: "Daylight Saving Time",
      ADD_DST: "Add DST",
      LINK: "Link",
      COPY_LINK_SUCCESS: "Link successfully saved to clipboard.",
      IS_ASUSLOGIN: "Does customer need to log in?",
      IS_MAILVERIFY: "Email Second Verification",
    },
    ASP: {
      SELECT_COUNTRY: "ASP Setting - Select Country",
      TITLE: "ASP List",
      TH_COUNTRY: "Country ID",
      TH_ASPNAME: "ASP Name",
      TH_ASPSKILL: "Skill",
      TH_ASPCOUNT: "ASP Quantity",
      TH_SUPPORT_COUNTRY: "Support Country",
      TH_ISACTIVE: "Service is Active or Not",
      TH_NOTE: "The remarked Office is an ASP with multi-nation support",
      FORM_TITLE_CREATE: "Establish the ASP",
      FORM_TITLE_EDIT: "ASP Management",
      FORM_NAME: "ASP Name",
      FORM_ON: "Service is activated",
      FORM_ON_TIPS: "Activate and ASP can provide services.",
      FORM_ITEM: "Serivce items (skills)",
      FORM_ITEM_TIPS: "Service skills that ASP provides",
      FORM_TRANSFER: "Transferred between Agents",
      FORM_TRANSFER_TIPS:
        "With this option turned on, agents under the same ASP can transfer service skills to each other",
      FORM_TRANSFER_ASP: "Can transfer to other ASP",
      FORM_TRANSFER_ASP_TIPS: "Transfer to other ASP in the same country",
      FORM_TRNASFER_COUNTRY: "Multi-national ASP support",
      FORM_TRNASFER_COUNTRY_TIPS:
        "Support ASP services in the same countries/region. Please leave it blank if it's not available",
    },
    SKILL: {
      COUNTRY: {
        SELECT_COUNTRY: "Country Skill Setting - Select Country",
        TITLE: "Manage Country Skill",
        TH_SINGLE_SERVICE: "Single Service Time",
        TH_SINGLE_SERVICE_INFO:
          "The service hours for all skills will follow the 'Single Service Time' setting.",
        TH_SKILL_GLOBAL: "Skill (Global)",
        TH_SKILL_TAG: "Skill (TAG)",
        TH_SKILL_LOCAL: "Skill name (Local)",
        TH_HANDLETIME: "Handle Time",
        TH_DAY: "Day",
        TH_TIME: "Time",
        TH_NOTE: "Time for Skill Service",
        FORM_TITLE_CREATE: "Establish new Skill",
        FORM_TITLE_EDIT: "Edit/Manage Skill",
        FORM_SUBTITLE_1: "Skill Settings",
        FORM_SUBTITLE_2: "Add Service Hour",
        FORM_SUBTITLE_3: "Service Hour",
        FORM_SKILL: "Skill",
        FORM_SKILL_LOCAL: "Skill Name(Local)",
        FORM_SKILL_STATUS: "Skill Status",
        FORM_SKILL_DISPLAY: "Display",
        FORM_SKILL_HIDDEN: "Hidden",
        FORM_HANDLETIME: "Skill Handle Time",
        FORM_PRODUCT: "Product",
        FORM_SELECTDAY: "Select Date",
        FORM_STARTTIME: "Start Time",
        FORM_ENDTIME: "End Time",
        FORM_ADD: "Skill added at",
        OFFDAY: "Day-off",
      },
      REGION: {
        TITLE: "Regional Skill Setting",
        SKILL_GLOBAL: "Skill Name (Global)",
        SKILL_TAG: "Skill name (TAG)",
      },
      SCHE: {
        SELECT_COUNTRY: "Skill Day-off Schedule - Select country",
        TITLE: "Skill Day-off Schedule",
      },
    },
    ACC: {
      TITLE: "Account Management",
      TITLE_CREATE: "Create new Account",
      TITLE_EDIT: "Edit the Account",
      COUNTRY: "Country",
      USERNAME: "User name",
      ROLE: "Role",
      ASP: "ASP",
      SKILL: "Skill",
      WEBRTC: "Video Call Lite",
      EMAIL: "Email",
      IS_FAKE_EMAIL: "Non-Receiving Email",
      CHANGE_PSW: "Change Password",
      PSW: "Password",
      PSWCONFIRM: "Password Confirm",
      RANDOM_PSW: "Random Password & Copy",
      STATUS: "Enable Account",
      MAXSERVICECOUNT: "Max. chat Q'ty",
      ISSERVICE: "Provide service",
      ISSERVICE_TRANSFER_ONLY: "Serve for Transfer Cases Only",
      MANUAL_TRANSFER_ONLY: "Manual transfer only",
      ACD_MONITOR: "ACD Monitor settings",
      USERNAME_INFO:
        "Please input 6 to 20 characters (Number mixed with English letter.",
      PASSWORD_INFO: "Please follow the password format below.",
      ACC_SETTING: "Account Setting",
      BASIC_SETTING: "Basic Setting",
      AVATAR: "Profile photo",
      UPLOAD_AVATAR: "Upload/Change Profile photo",
      NAME: "Name",
      FIRSTNAME: "FirstName",
      LASTNAME: "LastName",
      NICKNAME: "Nickname",
      GENDER: "Gender",
      MALE: "Male",
      FEMALE: "Female",
    },
    SELECT_COUNTRY: {
      COUNTRYCODE: "Country Code",
      COUNTRYNAME: "Country Name",
    },
    EC_LOGIN: {
      TITLE: "Online Store - setting for ASUS membership login",
      DESC: "To ask the customer to login the ASUS membership, please enable the setting.",
      TH_REGION: "Region",
      TH_COUNTRYNAME: "Country",
      TH_ACTION: "Action",
    },
    GPT: {
      SELECT_COUNTRY: "ChatBot Setting - Select Country",
      TITLE: "ChatBot Basic Setting",
      SYSTEM: {
        TITLE: "System Copy Setting",
        PRIVACY: "Privacy Statement",
        SERVICE_TITLE: "Serice/Non-Serice Hours Announcement",
        SERVICE: "Serice Hours Announcement",
        NON_SERVICE: "Non-Serice Hours Announcement",
        NON_SERVICE_REPLY: "Non-Serice Hours Reply",
        NON_SERVICE_BTN: "Button Text",
        NON_SERVICE_URL: "Enter the URL",
        IDLE: "User Idle",
        IDLE_LABEL: "Idle warning(S)",
        IDLE_DESC:
          "When users are idle beyond the time, an idle message will be displayed. (Unit: seconds)",
        OFFLINE: "User Disconnected",
        OFFLINE_MSG: "Offline message",
        OFFLINE_TIME: "Offline time(S)",
        OFFLINE_DESC:
          "When users remain idle beyond the time, a disconnection message will be displayed. (Unit: seconds)",
        SENTENCE: "Limitation on Conversation Count",
        SENTENCE_MSG: "Service termination message",
        SENTENCE_LABEL: "Conversation count settings (times)",
        SENTENCE_DESC:
          "When the number of conversations exceeds the specified limit, a service termination message will be displayed. (Unit: times)",
        IP_LIMIT_LABEL: "Daily AI reply limit per IP (times)",
        IP_LIMIT_DESC:
          "When an IP exceeds the daily limit of AI replies, a service termination message will be displayed. Decision Tree is not affected. (Unit: times)",
        SAT: "The Count of Unsatisfaction(dislikes)",
        SAT_LABEL: "The count of dislikes",
        SAT_DESC:
          "If the user dislikes the BOT's reply for a specified number of times, a message indicating a transfer to an agent will be displayed. (Unit: times)",
        SAT_SWITCH: "Satisfaction survey",
        SAT_DISLIKE: "Dislike Reason",
        TOAGENT: "Trigger to Agent",
        TOAGENT_MSG: "Trigger to Agent Message",
        TOAGENT_LABEL: "Parameter Settings (times)",
        TOAGENT_DESC: "Display the trigger to agent message. (Unit: times)",
        AD: "AD Setting",
        AD_URL: "Enter the URL",
        AD_PIC: "Upload New Picture (Recommended Size 330*120)",
        AD_NEW: "Add AD",
        BOT: "BOT Message/Reply Settings",
        BOT_LABEL: "Message",
        BOT_NEW: "Add Message",
        BOT_WELCOME: "Welcome message",
        BOT_TEC: "Technical Support Reply",
        BOT_PRODUCT: "Product Line Reply",
        BOT_BOT: "BOT Solution Introduction",
        BOT_END: "End Chat Message",
        BOT_NOSERVICE: "No-service Hour",
        BOT_REPAIR: {
          TITLE: "Repair Status Reply Settings",
          INPUT: "SN/RMA No.Input Guidelines",
          RECORD: "Repair Records Found",
          NORECORD: "Repair Records Not Found (Disabled)",
          NOSN: "SN Not Found",
          ERRORTIMES: "SN Error Limit",
          TOAGENT: "Trigger to Agent Message",
        },
        BOT_WARRANTY: {
          TITLE: "Warranty Reply Settings",
          INPUT: "SN/RMA No.Input Guidelines",
          RECORD: "Warranty Found",
          NORECORD: "Warranty Not Found (Disabled)",
          NOSN: "SN Not Found",
          ERRORTIMES: "SN Error Limit",
          TOAGENT: "Trigger to Agent Message",
        },
      },
      DECISION_TREE: "Decision Tree Setting",
      TREE: {
        NORMAL: "Normal",
        NAME: "Name",
        STYLE: "Style",
        OPTION: "Options",
        EDIT: "Edit",
        SORT: "Sort",
        NEWLAYER: "New Layer",
        EDITLAYER: "Edit Layer",
        KEYNAME: "Intent",
        TITLE: "Title",
        SUBTITLE: "SubTitle",
        IS_SURVEY: "Like/Dislike",
        DISPLAY: "Display",
        TOAGENT: "To Agent Only",
        TOAGENT_DESC: "Description",
        TOAGENT_NONSERVICE: "Customized Non-Service Hour Reply",
        LINK_STYLE: "Link Style Setting",
        LINK: "Link",
        LINK_BTNTEX: "Button Text",
        LINK_BLANK: "Open in a new window",
        CARD_STYLE: "Card Style Setting",
        CARD_IMAGE: "Image",
        CARD_BTNTEXT: "Button Text",
        GPTLINK: "Product Line",
        CHILD_LAYER_STYLE: "Sub-layer list style",
        CHILE_LAYER_OPT1: "Text",
        CHILE_LAYER_OPT2: "Link",
        CHILE_LAYER_OPT3: "Link(with BOT)",
        CHILE_LAYER_OPT4: "Card(with link)",
        CHILE_LAYER_OPT5: "Card(with BOT)",
        CHILD_LAYER_OPT_DESC:
          "※The style presented by the sub-layer list (if any)",
        CHILD_LAYER_DESC: "Sub-layer list description",
        TUTORIAL: "Tutorial",
        TUTORIAL_MODE: "Tutorial Mode",
        TUTORIAL_INTENT: "Intent",
        TUTORIAL_TITLE: "Title",
        TUTORIAL_CONTENT: "Content",
        TUTORIAL_ICON: "Icon",
        TUTORIAL_NEW: "Add Tutorial",
      },
      SAT: {
        TITLE: "Satisfaction Survey Option Setting",
      },
      SN_BLOCK: {
        TITLE: "SN Block List Setting",
      },
    },
  },
  NOTIFY: {
    ROLE: "Role",
    AREA: "Area",
    STATUS_SETTING: "Status Setting",
    LOGIN: "Login",
    READY: "Ready",
    BREAK: "Break",
    LUNCH: "Lunch",
    ACW: "After Chat work",
    MEETING: "Meeting",
    COACHING: "Internal training",
    LOGOUT: "Log Out",
  },
  MESSAGECENTER: {
    TITLE: "Message Center",
    NO_MSG: "No message",
    CHANGEPSW: "Please update your new password before {date}.",
    KB_LAG: "Please complete the KB preferred language setting",
    FIRST_CHANGEPSW:
      "To ensure the security of your account, we recommend regularly changing your password. Would you like to change your password now? Click 'Confirm' to proceed with password change, or click 'Later' to handle it at a later time.",
  },
  VIDEO: {
    VIDEO_READY: "Video chat has already running.",
    CONFIRM: {
      TITLE: "Start a video  invitation(Beta)",
      TEXT: "Are you sure you want to send the video chat invitation?(Beta)",
      HANGUP: "Hangup",
      HANGUP_TEXT: "Are you sure you want to end the video chat?",
    },
    MESSAGE: {
      INVITE_MSG:
        'You have sent a video invitation to the customer. To cancel the invitation, please click "Cancel Video Invitation"',
      CANCEL_INVITE: "Cancel Video Invitation",
    },
    LAYOUT: {
      DEVICE_NOT_FOUND: "Webcam not found.",
      DEVICE_NOT_FOUND_INFO:
        "Your device was not detected, please make sure you have allowed the website to use your camera and microphone or if the device is already occupied by another application.",
      LOCAL_WEBCAM: "Your stream",
      DRAG: "Click here to drag the window",
      CLIENT_HANGUP: "Client has actively hung up the video connection",
      CLIENT_REFUSES: "The other party declined the video invitation",
    },
  },
  VIDEOCALL: {
    TITLE: "Video Call Lite (Beta)",
    READY: "Ready for Video Call",
    ENDED: "Video Call Ended",
    WAITING: "Waiting for client connection...",
    IN_PROGRESS: "Video Chat in progress",
    BACK_TO_CURRENT: "Back to current video chat",
    RECORD_ING: "Recording",
    RECORD_PAUSE: "Recording Paused",
    RECORD_END: "Recording Ended",
    CREATE: {
      SN_ERROR: "Invalid Serial Number.",
    },
    CUSTOMER_ENDED: "Customer has ended the Video Call",
    END: "End The Video Call",
    END_DESC:
      "Whether to close the chat room, press 'Confirm' to end the chat room. (Users can no longer enter chat rooms through links.)",
  },
  FUNNEL: {
    TITLE: "Funnel Chart (Beta)",
    ENTER_URL: "Please enter the URL",
    RESULT: "Result",
  },
};
export default en;
